import { Button } from "@msuite/ui/button";
import type { Disclosure } from "@msuite/ui/hooks";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu, type MenuItems } from "@msuite/ui/menu";

/** Props Interface */
interface ContentCardMenuProps {
	disclosure: Disclosure;
	menuItems?: MenuItems;
	menuLabel?: string;
	isCollapsible?: boolean;
}

export function ContentCardMenu({
	disclosure,
	menuItems,
	menuLabel,
	isCollapsible = true,
}: ContentCardMenuProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="-m-2">
			<Menu
				items={() => [
					{
						label: disclosure.isOpen ? t("disclosure.collapse") : t("disclosure.expand"),
						onClick: disclosure.onToggle,
						icon: icon("FoldVertical"),
						isDisabled: !isCollapsible,
						closesMenu: true,
					},
					...(menuItems ?? []),
				]}
			>
				<Button
					variant="ghost"
					size="xxs"
					icon={<Icon name="EllipsisVertical" />}
				>
					{menuLabel}
				</Button>
			</Menu>
		</div>
	);
}
